// extracted by mini-css-extract-plugin
module.exports = {"iframe":"CordovaExternalWebsite__iframe___3GTS-"};